import Swal from "sweetalert2";
import JQuery from "jquery";

export function networkError() {
  Swal.fire({
    icon: "error",
    title: "Oops!...",
    text: "Something went wrong! Please check your connection and try again.",
    reverseButtons: true,
    confirmButtonText: "ok",
    cancelButtonText: "cancel"
  });
}
export function scroll(offset = 20, speed = 600) {
  // eslint-disable-next-line no-undef
  JQuery("html, body").animate({ scrollTop: offset }, speed);
}

export function toggleFormLoading(context) {
  context.$store.dispatch("global/form_loading");
}
